import { render, staticRenderFns } from "./TagsEve.vue?vue&type=template&id=3539ec48&"
import script from "./TagsEve.vue?vue&type=script&lang=js&"
export * from "./TagsEve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports